import Box from '@mui/material/Box'
import { CheckBox } from '../../1elements'

const MapSearchRangeCheckBox = ({ checked, onChange, className }) => (
    <Box className={className} sx={{
        backgroundColor: '#FFFFFF',
        borderRadius: '5px',
        display: 'flex',
        height: '40px',
        minWidth: '160px',
        padding: '8px'
    }}>
        <CheckBox
            checked={checked}
            onChange={onChange}
            label='Zoomed Area Only'
        />
    </Box>
)

export default MapSearchRangeCheckBox
